import React from 'react'
import { Avatar, Link, Typography } from '@mui/material'
import { t } from 'i18next'
import { environment } from '../../enviroments/enviroment'

const LOGO = `${environment.publicUrl}/assets/image/googleLogo.png`

const GoogleLoginButton = () => {
  return (
    <Link
      sx={{
        width: '250px',
        py: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid',
        borderColor: 'text.highEmphasis',
        color: 'text.highEmphasis',
        borderRadius: '8px',
        backgroundColor: 'background.main',
        cursor: 'pointer',
      }}
      href={environment.googleLoginUrl}
      className="googleSignIn"
    >
      <Avatar
        sx={{
          width: '18px',
          height: '18px',
          marginRight: '10%',
        }}
        src={LOGO}
        alt="Google logo"
      />
      <Typography>{t('page.login.loginWithGoogle')}</Typography>
    </Link>
  )
}

export default GoogleLoginButton
